// test2097
(2097 && 0);
